import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleEstimate = {
  namespaced: true,

  state: {
    name: 'estimate',
    nextSeqCode: null,
    estimates: [],
  },

  mutations,
  getters,
  actions
}

export default moduleEstimate;